<template>
  <span id="print-bill-of-lading" v-if="$can(permissions.OUTBOUND.VIEW_BILL_OF_LADINGS)">
    <el-tooltip class="item" effect="dark" :content="$t('customerService.billOfLading.print')" placement="top-start">
      <i class="el-icon-printer icon-action" @click="dialogVisible = true" />
    </el-tooltip>
    <el-dialog
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('customerService.billOfLading.print')"
      class="dialog-with-cols"
    >
      <el-row>
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="printDetailedBol()">
            {{ $t('outbound.loads.detailedBol') }}
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="printBol()">
            {{ $t('outbound.loads.bol') }}
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import { Loading } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'PrintBillOfLading',
  data() {
    return {
      dialogVisible: false,
    };
  },
  props: {
    bolId: {
      type: Number,
      default: null
    }
  },
  methods: {
    async printDetailedBol() {
      const loading = Loading.service(constants.LOADING.PRINT_DETAILED_BILL_OF_LADING);
      await this.$store.dispatch('billOfLading/printDetailed', this.bolId)
        .finally(() => loading.close());
      this.dialogVisible = false;
    },
    async printBol() {
      const loading = Loading.service(constants.LOADING.PRINT_BILL_OF_LADING);
      await this.$store.dispatch('billOfLading/print', this.bolId)
        .finally(() => loading.close());
      this.dialogVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
#print-bill-of-lading {
  .el-button {
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
